<template>
    <section>
        <div v-if="loading" class="content content-centered">
            <pulse-loader></pulse-loader>
        </div>
        <div v-show="!loading" class="content">
            <div class="box">
                <div class="box-body">
                    <div class="row">
                        <div class="flash-message col-md-4 col-md-offset-4 text-center" v-if="flash">
                            <div class="alert" :class="'alert-' + flashType">{{ flashMessage }}</div>
                        </div>
                    </div>
                    <div id="details">
                        <vue-form :state="formstate" @submit.prevent="onSubmit" class="row">
                            <div class="col-sm-12">
                                <div class="col-sm-6">
                                    <validate auto-label class="form-group required-field" :class="fieldClassName(formstate.siteName)">
                                        <label>Location Name</label>
                                        <input type="text" minlength="3" name="siteName" class="form-control" required v-model.lazy="site.siteName" placeholder="Location Name">
                                        <field-messages name="siteName" show="$touched || $submitted" class="form-control-feedback">
                                            <div slot="required">Location name is a required field</div>
                                            <div slot="pattern">Location name is invalid</div>
                                            <div slot="minlength">Minimum length of Location is 3 character</div>
                                        </field-messages>
                                    </validate>
                                </div>
                                <div class="col-sm-6">
                                        <validate auto-label class="form-group required-field" :class="fieldClassName(formstate.region)">
                                            <label>Geographical Area</label>
                                            <select v-model="site.region" required name="region" class="form-control">
                                                <option disabled>Select G.A</option>
                                                <option v-for="(item,index) in region_list" :key="index" :value="item.key">
                                                    {{item.value}}
                                                </option>
                                            </select>
                                        </validate>
                                        <field-messages name="region" show="$touched || $submitted" class="form-control-feedback">
                                            <div slot="required">Geographical Area is a required field</div>
                                        </field-messages>
                                </div>
                            </div>
                            <div class="col-sm-12">
                                <div class="col-sm-6">
                                    <validate auto-label class="form-group required-field" :class="fieldClassName(formstate.siteType)">
                                        <label>Location Type</label>
                                        <select required v-model="site.siteType" name="siteType" class="form-control">
                                            <option value="MS">Mother Station</option>
                                            <option value="DBS">Daughter Station</option>
                                        </select>
                                        <field-messages name="siteType" show="$touched || $submitted" class="form-control-feedback">
                                            <div slot="required">Location Type is a required field</div>
                                        </field-messages>
                                    </validate>
                                </div>
                                <div class="col-sm-3">
                                    <validate auto-label class="form-group required-field" :class="fieldClassName(formstate.status)">
                                            <label>Status</label>
                                        <select required v-model="site.status" name="siteType" class="form-control">
                                            <option value="active">Active</option>
                                            <option value="inactive">Inactive</option>
                                        </select>
                                        <field-messages name="status" show="$touched || $submitted" class="form-control-feedback">
                                            <div slot="required">Status is a required field</div>
                                        </field-messages>
                                    </validate>
                                </div>
                                <div class="col-sm-3">
                                    <validate auto-label class="form-group required-field" :class="fieldClassName(formstate.deviceId)">
                                        <label>Device</label>
                                        <select v-model="site.deviceId" required name="deviceId" class="form-control">
                                            <option value="" disabled>Select Device</option>
                                            <option v-for="(item,index) in device_id" :key="index" :value="item.key">
                                                {{item.value}}
                                            </option>
                                        </select>
                                        <field-messages name="deviceId" show="$touched || $submitted" class="form-control-feedback">
                                            <div slot="required">Device is a required field</div>
                                        </field-messages>
                                    </validate>
                                </div>
                            </div>
                            <div class="col-sm-12">
                                <div class="col-sm-6">
                                    <validate auto-label class="form-group required-field" :class="fieldClassName(formstate.salesManager)">
                                        <label>Sales Manager</label>
                                        <select v-model="site.salesManager" required name="supervisor" class="form-control">
                                            <option disabled>Select Manager</option>
                                            <option v-for="(item,index) in sales_managers" :key="index" :value="item.key">
                                                {{item.value}}
                                            </option>
                                        </select>
                                        <field-messages name="regionRegionManager" show="$touched || $submitted" class="form-control-feedback">
                                            <div slot="required">Sales Manager is a required field</div>
                                        </field-messages>
                                    </validate>
                                </div>
                                <div class="col-sm-6">
                                    <validate auto-label class="form-group required-field" :class="fieldClassName(formstate.capacity)">
                                        <label>Capacity (in SCM)</label>
                                        <input type="number" min="1" max="9999999" name="capacity" class="form-control" required v-model.lazy="site.capacity" placeholder="Capacity">
                                        <field-messages name="capacity" show="$touched || $submitted" class="form-control-feedback">
                                            <div slot="required">Capacity is a required field</div>
                                            <div slot="min">Maximum capacity is 1</div>
                                            <div slot="max">Maximum capacity is 9999999</div>
                                        </field-messages>
                                    </validate>
                                </div>
                            </div>
                            <div class="col-sm-12">
                                <div class="col-sm-6">
                                    <label for="dateAdded">Commissioning Date</label>
                                    <validate auto-label class="form-group required-field" :class="fieldClassName(formstate.dateAdded)">
                                        <date-picker required id="dateAdded" v-model="site.dateAdded" lang="en" name="dateAdded" input-class="form-control" width="100%" use-utc="true" format="DD-MM-YYYY"></date-picker>
                                        <field-messages name="dateAdded" show="$touched || $submitted" class="form-control-feedback">
                                            <div slot="required">Commissioning date is a required field</div>
                                            <div slot="pattern">Commissioning date is invalid</div>
                                        </field-messages>
                                    </validate>
                                </div>
                                <div class="col-sm-6">
                                    <validate auto-label class="form-group required-field" :class="fieldClassName(formstate.email)">
                                        <label>Email</label>
                                        <input type="email" name="email" class="form-control" required v-model.lazy="site.email" placeholder="Email">
                                        <field-messages name="email" show="$touched || $submitted" class="form-control-feedback">
                                            <div slot="required">Email is a required field</div>
                                            <div slot="pattern">Email is invalid</div>
                                        </field-messages>
                                    </validate>
                                </div>
                            </div>
                            <div class="col-sm-12">
                                
                                    <div class="col-sm-3">
                                        <label for="latitude">Latitude</label>
                                        <validate auto-label class="form-group required-field" :class="fieldClassName(formstate.latitude)">
                                            <input type="number" minlength="2" name="latitude" class="form-control" required v-model.lazy="site.latitude" placeholder="Latitude">
                                            <field-messages name="latitude" show="$touched || $submitted" class="form-control-feedback">
                                                <div slot="required">Latitude is a required field</div>
                                                <div slot="pattern">Latitude is invalid</div>
                                            </field-messages>
                                        </validate>
                                    </div>
                                    <div class="col-sm-3">
                                        <label for="longitude">Longitude</label>
                                        <validate auto-label class="form-group required-field" :class="fieldClassName(formstate.longitude)">
                                            <input type="number" minlength="2" name="longitude" class="form-control" required v-model.lazy="site.longitude" placeholder="Longitude">
                                            <field-messages name="longitude" show="$touched || $submitted" class="form-control-feedback">
                                                <div slot="required">Longitude is a required field</div>
                                                <div slot="pattern">Longitude is invalid</div>
                                            </field-messages>
                                        </validate>
                                    </div>
                              
                                <div class="col-sm-6">
                                    <validate auto-label class="form-group required-field" :class="fieldClassName(formstate.address)">
                                        <label>Address</label>
                                        <textarea name="address" :maxlength="maxAddress" class="form-control" required v-model.lazy="site.address" placeholder="Address"></textarea>
                                        <field-messages name="address" show="$touched || $submitted" class="form-control-feedback">
                                            <div slot="required">Address is a required field</div>
                                            <div slot="pattern">Address is invalid</div>
                                            <div slot="maxlength">Maximum Address length is 150 characters</div> 
                                        </field-messages>
                                    </validate>
                                </div>
                            </div>
                            <div class="col-sm-12">
                                <div class="col-sm-6">
                                    <validate auto-label class="form-group" :class="fieldClassName(formstate.siteInfoImage)">
                                        <label>Location Image</label>
                                        <input type="file" @change="onFilechanged" class="form-control" name="siteInfoImage" />
                                        <field-messages name="siteInfoImage" show="$touched || $submitted" class="form-control-feedback">
                                            <div slot="required">Please upload less than 3mb picture</div>
                                        </field-messages>
                                    </validate>
                                </div>
                                <div class="col-sm-6">
                                    <validate auto-label class="form-group required-field" :class="fieldClassName(formstate.customerName)">
                                        <label>Customer Name</label>
                                        <select required name="customerName" class="form-control" v-model.lazy="site.customerName">
                                            <option>Think Gas</option>
                                            <option>IOCL</option>
                                            <option>HPCL</option>
                                            <option>BPCL</option>
                                            <option>Essar</option>
                                            <option>Reliance</option>
                                        </select>
                                        <field-messages name="customerName" show="$touched || $submitted" class="form-control-feedback">
                                            <div slot="required">Customer Name is a required field</div>
                                        </field-messages>
                                    </validate>
                                </div>
                            </div>
                            <div class="col-sm-12">
                                <div class="col-sm-6">
                                    <validate auto-label class="form-group required-field" :class="fieldClassName(formstate.supervisor)">
                                        <label>Location Supervisor(GA Head)</label>
                                        <select v-model="site.supervisor" required name="supervisor" class="form-control">
                                            <option disabled>Select GA Head</option>
                                            <option v-for="(item,index) in ga_managers" :key="index" :value="item.key">
                                                {{item.value}}
                                            </option>
                                        </select>
                                        <field-messages name="supervisor" show="$touched || $submitted" class="form-control-feedback">
                                            <div slot="required">GA Head is a required field</div>
                                        </field-messages> 
                                    </validate>
                                </div>
                                <div class="col-sm-6">
                                    <validate auto-label class="form-group" :class="fieldClassName(formstate.dispenserCount)">
                                        <label>Dispenser Count</label>
                                        <input type="number" max ="25" name="dispenserCount" class="form-control" v-model.lazy="site.dispenserCount" placeholder="Dispenser Count">
                                        <field-messages name="dispenserCount" show="$touched || $submitted" class="form-control-feedback">
                                            <div slot="required">Dispenser Count is a required field</div>
                                            <div slot="max">Maximum Dispenser can be 25</div>
                                        </field-messages>
                                    </validate>
                                </div>
                            </div>
                            <div class="col-md-12">
                                <legend class="col-md-12">Owner Details</legend>
                                <div class="col-sm-12">
                                    <div class="col-sm-6">
                                        <validate auto-label class="form-group required-field" :class="fieldClassName(formstate.ownerName)">
                                            <label>Customer Owner Name</label>
                                            <input type ="text"  :maxlength="max" required v-model="site.ownerName" name="ownerName" class="form-control" placeholder="Owner Name">
                                    
                                            <field-messages name="ownerName" show="$touched || $submitted" class="form-control-feedback">
                                                <div slot="required">Owner Name is a required field</div>
                                                <div slot="maxlength">Owner Name should not be more than 20 characters</div>
                                            </field-messages>
                                        </validate>
                                    </div>
                                    <div class="col-sm-6">
                                        <validate auto-label class="form-group required-field" :class="fieldClassName(formstate.ownerMobile)">
                                            <label>Mobile</label>
                                            <input type="ownerMobile" minlength="3" name="ownerMobile" class="form-control" required v-model.lazy="site.ownerMobile" placeholder="Owner Mobile" pattern="[78965][0-9]{9}">
                                            <field-messages name="ownerMobile" show="$touched || $submitted" class="form-control-feedback">
                                                <div slot="required">Owner mobile is a required field</div>
                                                <div slot="pattern">Mobile No is invalid</div>
                                            </field-messages>
                                        </validate>
                                    </div>
                                </div>
                                <div class="col-sm-12">
                                    <div class="col-sm-6">
                                        <validate auto-label class="form-group required-field" :class="fieldClassName(formstate.ownerEmail)">
                                            <label>Owner Email</label>
                                            <input type="email" minlength="3" name="ownerEmail" class="form-control" required v-model.lazy="site.ownerEmail" placeholder="Owner Email">
                                            <field-messages name="ownerEmail" show="$touched || $submitted" class="form-control-feedback">
                                                <div slot="required">Owner Email is a required field</div>
                                            </field-messages>
                                        </validate>
                                    </div>
                                    <div class="col-sm-6">
                                        <validate auto-label class="form-group required-field" :class="fieldClassName(formstate.ownerAddress)">
                                            <label>Address</label>
                                            <textarea type="ownerAddress" minlength="3" name="ownerAddress" class="form-control" required v-model.lazy="site.ownerAddress" placeholder="Owner Address"></textarea>
                                            <field-messages name="ownerAddress" show="$touched || $submitted" class="form-control-feedback">
                                                <div slot="required">Owner Address is a required field</div>
                                            </field-messages>
                                        </validate>
                                    </div>
                                </div>
                            </div>
                        </vue-form>
                        <div class="col-sm-12 text-right">
                            <router-link :to="{ name: 'Sites' }">
                                <button class="mr-5 btn btn-default" type="button">Cancel</button>
                            </router-link>
                            <button class="mr-2 btn gradientbt" type="submit" @click="createSite" :disabled="!(formstate.$dirty && formstate.$valid)">Add Location</button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </section>
</template>

<script>
  import { formService, eventBus , siteService} from '../../../services'
  import { EVENTS } from '../../../config'
  import axios from 'axios';
  import {mapState} from 'vuex';

  export default {
    name: 'SiteCreate',
    data () {
        return {
            loading: false,
            flash: false,
            flashType: null,
            flashMessage: '',
            EVENTS: EVENTS,
            formstate: {},
            sales_managers: {},
            region_list: {},
            ga_managers : {},
            device_id : {},
            maxAddress:150,
            max:20,
            photo:{},
            site : {
                status : 'active',
               siteInfoImage: ''
            }
        }
    },
    mounted: function() {
        this.getRegionList()
        this.getSalesManager()
        this.getGAHead()
        this.getDevice()
    },
    methods: {
        onFilechanged (event) {
            this.photo = event.target.files[0];
            this.site.siteInfoImage = event.target.files[0]['name']
        },
        fieldClassName: formService.fieldClassName,
        getDevice(){
            this.loading  = true;
            const params  = {}
            params.$limit = 0;
            //params.roleRank = 4;
            let deviceList = [];
            this.$deviceDataRepository.list(params)
                .then((res)=> {
                    this.loading  = false;
                    if (res.data.docs) {
                        deviceList =  res.data.docs.map((item)=> {
                            return {
                                key : item._id, 
                                value : item.deviceId,
                                
                            }
                        })
                       
                    }
                    this.device_id = deviceList;
                    
                })
                .catch((error) => {
                    this.loading  = false;
                    console.error('device.requestFunction-error:', error)
                    this.$snotify.error('Get device list failed', 'Error!')
                })
        },
        createSite () {
            this.loading = true;
            this.site ={
                ...this.site,
                siteInfoImage : JSON.stringify(this.site.siteInfoImage)
            }
            return siteService.addSite(this.site)
            .then((response) => {
                let docId = response._id
                this.uploadDocument(docId)
                this.loading = false
                this.flash = false
                this.$snotify.success('Location added!', 'Success!')
                this.$router.push('/location')
            })
            .catch(error => {
                this.loading = false
                this.$snotify.error('Location Add failed!Try Again', 'Error!')
                if (error.data.message.includes('must be one of')) {
                    this.flash = true
                    this.flashType = 'error'
                    this.flashMessage = 'New Location add is failed.Please try again!'
                }
            })
        },
        uploadDocument(docId){
            let formData = new FormData();
            formData.append('file', this.photo);
            formData.append('model',"location");
            formData.append("docId",docId)
                axios.post('fileUpload',
                    formData, {
                        headers: {
                            'Content-Type': 'multipart/form-data'
                        }
                    }
                ).then(res =>{
                    console.log(res)
                    console.log('SUCCESS!!');
                })
                .catch(function() {
                    console.log('FAILURE!!');
            });
        },
        getRegionList() {
            this.loading  = true;
            const params  = {}
            params.$limit = 0;
            if (this.user.roleName == "GA Head"){
                params.regionManager = this.user._id
            }
            let regionlist = [];
            this.$regionDataRepository.list(params)
                .then((res)=> {
                    this.loading  = false;
                    if (res.data.docs) {
                        regionlist =  res.data.docs.map((item)=> {
                            return {
                                key : item._id, 
                                value : item.name
                            }
                        })
                    }
                    this.region_list = regionlist;
                })
                .catch((error) => {
                    this.loading  = false;
                    console.error('Region.requestFunction-error:', error)
                    this.$snotify.error('Get Geographic Areas list failed', 'Error!')
                })
        },
        getSalesManager() {
            this.loading  = true;
            const params  = {}
            params.$limit = 0;
            params.roleRank = 4;
            let salesManagerList = [];
            this.$userRepository.list(params)
                .then((res)=> {
                    this.loading  = false;
                    if (res.data.docs) {
                        salesManagerList =  res.data.docs.map((item)=> {
                            return {
                                key : item._id, 
                                value : item.firstName +' '+item.lastName
                            }
                        })
                       
                    }
                    this.sales_managers = salesManagerList;
                })
                .catch((error) => {
                    this.loading  = false;
                    console.error('Sales Manager.requestFunction-error:', error)
                    this.$snotify.error('Get Sales manager list failed', 'Error!')
                })
        },
        getGAHead(){
           this.loading  = true;
            const params  = {}
            params.$limit = 0;
            params.roleRank = 2;
            let gaHeadList = [];
            this.$userRepository.list(params)
                .then((res)=> {
                    this.loading  = false;
                    if (res.data.docs) {
                        gaHeadList =  res.data.docs.map((item)=> {
                            return {
                                key : item._id, 
                                value : item.firstName +' '+item.lastName
                            }
                        })
                       
                    }
                    this.ga_managers = gaHeadList;
                })
                .catch((error) => {
                    this.loading  = false;
                    console.error('Sales Manager.requestFunction-error:', error)
                    this.$snotify.error('Get Sales manager list failed', 'Error!')
                })
        }, 

        
        fieldClassName: function (field) {
            if(!field) {
                return '';
            }
            if((field.$touched || field.$submitted) && field.$valid) {
                return 'has-success';
            }
            if((field.$touched || field.$submitted) && field.$invalid) {
                return 'has-danger';
            }
        }
    },
    computed:{
        ...mapState({
            user : state => state.auth.user,
        })
    }
  }
</script>
<style scoped>
    .required-field > label::after , label::after {
        content: '*';
        color: red;
        margin-left: 0.25rem;
    }
    .form-control-feedback {
        font-weight: 100;
        color: red;
        position: initial;
        text-align: left;
        height: auto;
        width: auto;
    }
    .has-danger {
        color: red
    }
    .gradientbt{
        background: #0F6940;
        color: white
    }
    


    
</style>



// WEBPACK FOOTER //
// SiteCreate.vue?835f3e12